import React from 'react';
import TableComponent from './TableComponent';
import { filterQSet } from '../utils/miscFunctions';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

class QSetSearchDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredQuestions: this.props.data,
            searchTerm: '',
            page: 0,
            rowsPerPage: 5
        };
        this.updateState = this.updateState.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.data.length !== prevProps.data.length) {
            this.setState({
                filteredQuestions: this.props.data
            })
        }
    }

    updateState(value, state){
        this.setState({
            [state]: value
        }, ()=> {
            if(state === 'searchTerm'){
                this.updateState(0, "page");
                console.log("Filtering");
                let filteredQuestions = this.props.data.filter(filterQSet(this.state.searchTerm));
                this.setState({
                    filteredQuestions: filteredQuestions
                })
            }
        })
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.toggleOpen}
                fullWidth={true}
                maxWidth={"md"}
            >
                <DialogContent>
                    <div style={{ display: 'flex', width: '100%' }}>
                        <TextField
                            id="search-input" variant="outlined"
                            value={this.state.searchTerm}
                            onChange={(e) => this.updateState(e.target.value, "searchTerm")}
                            InputProps={{ startAdornment: (<InputAdornment position="start"> <SearchIcon /> </InputAdornment>) }}
                            style={styles['search']}
                            autoComplete="off"
                        />
                    </div>
                    <div>
                        <TableComponent
                            data={this.state.filteredQuestions}
                            headers={["ID", "Description", "Fields","Date added"]}
                            fields={["id", "description", "fields", "dateAdded"]}
                            updateState={this.updateState}
                            onRowClick={this.props.onRowClick}
                            rowsPerPage={this.state.rowsPerPage}
                            page={this.state.page}
                            count={this.state.filteredQuestions.length}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.toggleOpen} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
};
    
const styles = {
    'search': {
        width: '50%',
        margin: 10
    },
    'select': {
        width: '22%',
        margin: 5,
        height: 60,
        fontSize: 16
    }
}


export default QSetSearchDialog;